
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"loadingError":"Beim Erstellen von Popup-Inhalten ist ein Fehler aufgetreten","emptyContent":"~Kein Inhalt verfügbar"},"en":{"loadingError":"An error occurred while creating popup content","emptyContent":"~No content available"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();